import { useMemo } from 'react';
import { useUnit } from 'effector-react';
import dayjs from 'dayjs';
import { $initialAccountsStore } from '@lib/store';
import { AccountType } from '@shared/api';
import { AccountsSummary } from './accountsSummary';
import { MonthlyTransaction } from './monthlyTransaction';
import { YearlyTransaction } from './yearlyTransaction';

export const PaymentTab = () => {
  const accountStore = useUnit($initialAccountsStore.store);

  const minimalDate = useMemo(() => {
    const paymentAccounts = accountStore.data.filter((account) => account.type === AccountType.Payment);
    return dayjs.min(paymentAccounts.map((account) => dayjs(account.dateCreated)))?.format();
  }, [accountStore.data]);
  return (
    <>
      <AccountsSummary />
      <MonthlyTransaction minimalYear={dayjs(minimalDate).year()} minimalMonth={dayjs(minimalDate).month() + 1} />
      <YearlyTransaction minimalYear={dayjs(minimalDate).year()} />
    </>
  );
};
